
(async function () {

    // Handle Product Query Form
    const waitlistForm = document.getElementById('waitlist-form');
    const customSwal = Swal.mixin({
      customClass: {
        confirmButton: 'button button--primary',
        cancelButton: 'button button--primary'
      },
      buttonsStyling: false
    });
  
    if (waitlistForm == undefined) {
      console.log('Waitlist form does not exist')
    } else {
      const myHeaders = new Headers();
      myHeaders.append('x-api-key', '6XHzlHGCFQ96QW6f4uxN44HCpGvXJf2yL7WN5XSg');
      myHeaders.append('Content-Type', 'application/json');

      // Handle form submission
      waitlistForm.addEventListener('submit', async e => {
        e.preventDefault();
  
        const formData = new FormData(e.target);
        const formProps = Object.fromEntries(formData);
  
        // Get Data from Inputs
        const payload = {
            "email": formProps.email_address != undefined ? formProps.email_address : null,
            "sku": formProps.sku != undefined ? formProps.sku : null,
            "title": formProps.title != undefined ? formProps.title : null,
            "handle": formProps.handle != undefined ? formProps.handle : null,
        }
  
        waitlistForm.classList.add('loadingOverlay');
  
        const res = await fetch('https://apis.needapart.co.nz/waitlist/create', {
          method: 'POST',
          headers: myHeaders,
          body: JSON.stringify(payload)
        }).then(res => res.json());
  
        waitlistForm.classList.remove('loadingOverlay');
  
        if (res.message) {
          customSwal.fire({
            title: 'Success!',
            text: `Thanks! We'll be in touch when more stock becomes available'`,
            icon: 'success',
          }).then((res) => {
            // If we need to reset form here, we can do that.
            // window.location.reload();
          })
        } else {
          customSwal.fire({
            title: 'Error!',
            html: 'Sorry, we have not received your request due to a system error. Please <a href="/pages/contact">contact us</a>',
            icon: 'error',
          }).then((res) => {
            // If we need to reset form here, we can do that.
            //window.location.reload();
          })
        }
      });
    }
  })();